import { useState, useMemo, useEffect } from "react";
import { useDebounce } from "use-debounce";
import { googlePlacesHelpers } from "../helpers/googlePlaces.js";
import createPlacesService from "../helpers/places.js";
const useAddressSuggestions = ({
  onChange,
  onReceiveAddress,
  name,
  value: externalValue,
  containerElement
}) => {
  const [internalValue, setInternalValue] = useState("");
  const [options, setOptions] = useState([]);
  const value = externalValue ?? internalValue;
  const [debouncedValue] = useDebounce(value, 200);
  const placesService = useMemo(() => {
    if (containerElement) {
      return createPlacesService(containerElement);
    }
  }, [containerElement]);
  const dispatchChange = (v) => {
    if (onChange) {
      onChange({
        currentTarget: {
          name: name || "",
          value: v
        }
      });
    } else {
      setInternalValue(v);
    }
  };
  const handleInputChange = (_, v, reason) => {
    if (reason === "input") {
      dispatchChange(v);
    }
  };
  const handlePlacePredictions = setOptions;
  const handleChange = (_, option, reason) => {
    const isAutocompletePrediction = typeof option === "object";
    if (reason === "selectOption" && isAutocompletePrediction) {
      const autocompletePrediction = option;
      placesService == null ? void 0 : placesService.getPlaceDetails({ placeId: autocompletePrediction.place_id, fields: ["address_components"] }).then((data) => {
        if (!data)
          return;
        const address = googlePlacesHelpers.parsePlaceDetails(data);
        const value2 = [address.street, address.number].filter(Boolean).join(" ");
        if (value2)
          dispatchChange(value2);
        if (onReceiveAddress)
          onReceiveAddress(address);
      }).catch(() => {
      });
    }
  };
  useEffect(() => {
    if (debouncedValue) {
      placesService == null ? void 0 : placesService.getPlacePredictions({ input: debouncedValue }).then(setOptions).catch(() => {
      });
    }
  }, [placesService, debouncedValue, handlePlacePredictions]);
  return {
    value,
    options,
    handleChange,
    handleInputChange
  };
};
export {
  useAddressSuggestions
};
